<template>
  <div>
    <b-card-body>
      <div class="row mx-md-n3 mx-1 mb-2 align-items-end">
        <div class="col-sm-6 col-12 mb-sm-0 mb-3">
          <b-form-group
            label="Número do Lote"
            label-for="lotsSearchText"
            class="mb-0"
          >
            <b-form-input
              id="lotsSearchText"
              v-model="lotsSearchText"
              @keyup.enter="lotsSearchButtonPressed"
              placeholder="Procurar por..."
            />
          </b-form-group>
        </div>
        <div class="col-sm-auto col-6">
          <b-dropdown text="Filtros" class="mobile-btn-100">
            <b-dropdown-form>
              <div class="row">
                <div class="col-sm-6 col-12">
                  <b-form-group
                    label="Data Inicial"
                    label-for="lotsStartDate"
                  >
                    <b-form-input
                      id="lotsStartDate"
                      v-model="lotsStartDateStr"
                      required
                      type="date"/>
                  </b-form-group>
                </div>
                <div class="col-sm-6 col-12">
                  <b-form-group
                    label="Data Final"
                    label-for="lotsEndDate"
                  >
                    <b-form-input
                      id="lotsEndDate"
                      v-model="lotsEndDateStr"
                      required
                      type="date"/>
                  </b-form-group>
                </div>
              </div>
              <b-form-group
                label="Apenas com estoque"
              >
                <b-form-checkbox v-model="onlyPositiveItemLots"></b-form-checkbox>
              </b-form-group>
              <b-form-group
                label="Armazém"
              >
                <div v-if="loadingWarehouses">
                  <loading-animation />
                </div>
                <model-list-select
                  :list="warehouses"
                  option-value="id"
                  option-text="name"
                  v-model="lotsSelectedWarehouse"
                  placeholder="Selecione o Armazém"
                />
              </b-form-group>
              <b-form-group
                label="Endereço"
              >
                <div v-if="locationsFilter.loading">
                  <loading-animation />
                </div>
                <model-list-select
                  :list="locationsFilter.locations"
                  option-value="id"
                  option-text="name"
                  v-model="lotsSelectedLocation"
                  placeholder="Selecione o Endereço"
                  @searchchange="locationsFilterChanged"
                  :filterPredicate="alwaysTrueFilterPredicate"
                />
              </b-form-group>
            </b-dropdown-form>
          </b-dropdown>
        </div>
        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-6">
          <button @click="lotsSearchButtonPressed" type="button" class="btn btn-primary mobile-btn-100">Buscar</button>
        </div>
      </div>

      <div v-if="lotAppliedFilters.length" class="row mb-2 mx-0">
        <div v-for="(filter, index) in lotAppliedFilters" class="col-auto px-1" :key="index">
          <h4>
            <span class="badge badge-warning">{{filter.label}} = {{filter.value}}</span>
          </h4>
        </div>
      </div>

      <div class="row mx-md-n3 mx-1">
        <b-col sm="12">
          <div v-if="loadingItemLots" class="mb-5 pb-5">
            <loading-animation />
          </div>

          <div v-if="!loadingItemLots && !itemLots.length" class="mb-3">
            <div class="row bg-light mx-0 py-3">
              <div class="col text-center">
                Nenhum lote encontrado para a pesquisa
              </div>
            </div>
          </div>

          <div v-if="!loadingItemLots && itemLots.length" class="mb-3">
            <div v-for="(item, index) in itemLots" class="row py-3 border mx-0" :key="index"
              :class="{ 'bg-light': index % 2 != 0 }">

              <div class="col-12">
                <div class="row">
                  <div class="col-sm-6 col-12">
                    <span class="font-weight-bold">Número: </span>{{item.lotNumber}}
                  </div>
                  <div class="col-sm-6 col-12">
                    <span class="font-weight-bold">Código de barras: </span>{{item.barcode}}
                  </div>
                  <div class="col-sm-6 col-12">
                    <span class="font-weight-bold">Data: </span>{{item.formattedDate}}
                  </div>
                  <div class="col-sm-6 col-12">
                    <span class="font-weight-bold">Vencimento: </span>{{item.formattedDue}}
                  </div>
                </div>
              </div>

              <div class="col-12 mt-1">
                <div class="row align-items-center">

                  <div class="col-sm col-12">
                    <span class="font-weight-bold">Quantidade Atual: </span>
                    <composite-item-lot-quantity
                      :quantity="item.quantity"
                      :itemLot="item"
                    ></composite-item-lot-quantity>
                  </div>

                  <div class="col-sm-auto col-12">
                    <div class="row align-items-end">

                      <div v-if="isUserManager" class="col pr-0">
                        <b-button variant="secondary"
                          @click="openItemLotUpdateModal(index)"
                          class="mobile-btn-100">
                          <i class="fa fa-edit"></i> Editar
                        </b-button>
                      </div>

                      <div class="col-auto pl-0">
                        <div class="row justify-content-end align-items-center">
                          <h4 class="col-auto mb-0 pr-0">
                            <i :class="'cui-check ' + (item.printed ? 'text-success' : 'text-white')"></i>
                          </h4>
                          <div class="col-auto">
                            <b-button :variant="item.printed ? 'secondary' : 'primary'"
                              @click="openBarcodesPrintModal(index)"
                              :disabled="loadingBarcodePDF"
                              class="mobile-btn-100">
                              Gerar PDF
                            </b-button>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>

                </div>
              </div>

            </div>
          </div>

          <nav>
            <b-pagination
              align="center"
              :limit="10"
              :total-rows="lotsTotalRows"
              :per-page="lotsPerPage"
              prev-text="Anterior"
              next-text="Próximo"
              number-of-page="numberOfPages"
              v-model="lotsCurrentPage"
              @change="lotsPageChanged"
              :disabled="loadingItemLots"/>
          </nav>
        </b-col>
      </div>
    </b-card-body>

    <item-lot-update-modal
      :itemLot="itemLots[itemLotEditIndex]"
      :saved="itemLotSaved"
      ref="itemLotUpdateModal"
    ></item-lot-update-modal>

    <b-modal
      id="barcodes-print-modal"
      centered
      size="md"
      lazy
      title="Imprimir códigos de barra"
      header-bg-variant="info"
      footer-border-variant="info"
      v-model="showBarcodesPrintModal">
      <b-container>
        <div v-if="loadingBarcodePDF">
          <loading-animation />
        </div>

        <b-form-group
          v-else
          label="Modelo de etiqueta"
        >
          <model-list-select
            :list="barcodePrintModels"
            option-value="formOptionValue"
            option-text="label"
            v-model="barcodePrintModel"
          />
        </b-form-group>
      </b-container>

      <template slot="modal-footer" slot-scope="{ ok, cancel }">
        <b-button variant="secondary" @click="closeBarcodePrintModal">Cancelar</b-button>
        <b-button variant="primary" @click="printBarcodes" :disabled="generatePDFButtonDisabled">
          Gerar PDF
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import { LoadingAnimation } from '@/components/loaders'
  import { httpClient } from '@/service';
  import shared from '@/shared/shared'
  import { ModelListSelect } from 'vue-search-select'
  import CompositeItemLotQuantity from '@/components/common/composite-item-lot-quantity';
  import ItemLotUpdateModal from '@/components/modals/item-lot-update-modal';
  import Axios from 'axios'
  import { auth } from "@/service";

  export default {
    name: 'item-lots',
    components: {
      LoadingAnimation,
      ModelListSelect,
      CompositeItemLotQuantity,
      ItemLotUpdateModal
    },

    props: {
      item: {
        type: Object,
        required: true
      },
      loadingWarehouses: {
        type: Boolean,
        required: true
      },
      warehouses: {
        type: Array,
        required: true
      },
      alwaysTrueFilterPredicate: {
        type: Function,
        required: true
      },
      isUserManager: {
        type: Boolean,
        required: true
      },
      searchLocations: {
        type: Function,
        required: true
      },
      lotsSearchedCallback: {
        type: Function,
        required: true
      },
      locationsFilter: {
        type: Object,
        required: true
      }
    },

    data () {
      return {
        lotsSearchText: null,
        lotsCurrentPage: 1,
        lotsPerPage: 10,
        lotsTotalRows: 10,
        lotsStartDateStr: '',
        lotsEndDateStr: '',
        lotsSelectedWarehouse: {},
        onlyPositiveItemLots: false,
        loadingItemLots: false,
        itemLots: [],
        lotsSelectedLocation: {},
        itemLotEditIndex: -1,
        showBarcodesPrintModal: false,
        barcodePrintInitialModel: null,
        barcodePrintModel: null,
        barcodePrintModels: [],
        printItemLotIndex: null,
        loadingBarcodePDF: false,
        config: {},
        itemLotsSearched: false,
      }
    },

    beforeMount: function () {
      let today = new Date();
      let thisMonthMinus3 = new Date();
      thisMonthMinus3.setMonth(thisMonthMinus3.getMonth() - 3);

      this.lotsStartDateStr = thisMonthMinus3.toJSON().substring(0, 10);
      this.lotsEndDateStr = today.toJSON().substring(0, 10);

      this.lotsSearchText = shared.getLocalStorageString('items/show/Lots/lotsSearchText', this.lotsSearchText);
      this.lotsSelectedWarehouse = shared.getLocalStorageObj('items/show/Lots/lotsSelectedWarehouse', this.lotsSelectedWarehouse);
      this.lotsSelectedLocation = shared.getLocalStorageObj('items/show/Lots/lotsSelectedLocation', this.lotsSelectedLocation);
      this.onlyPositiveItemLots = shared.getLocalStorageString('items/show/Lots/onlyPositiveItemLots', this.onlyPositiveItemLots);

      this.config = shared.getConfig();
      this.barcodePrintInitialModel = this.config.printConfig.model;
      this.barcodePrintModel = this.barcodePrintInitialModel;
    },

    mounted: function () {
      this.$nextTick(() => {
        this.getItemLotPrintModels();
      });
    },

    computed: {
      lotAppliedFilters() {
        let appliedFilters = [];

        if (this.lotsSearchText && this.lotsSearchText.length) {
          appliedFilters.push({ label: 'Número do Lote', value: this.lotsSearchText });
        }

        if (this.lotsStartDateStr && this.lotsStartDateStr.length) {
          appliedFilters.push({ label: 'Data Inicial', value: shared.formatDate(this.lotsStartDateStr + 'T00:00:00', { dateOnly: true }) });
        }

        if (this.lotsEndDateStr && this.lotsEndDateStr.length) {
          appliedFilters.push({ label: 'Data Final', value: shared.formatDate(this.lotsEndDateStr + 'T00:00:00', { dateOnly: true }) });
        }

        if (this.onlyPositiveItemLots) {
          appliedFilters.push({ label: 'Apenas com estoque', value: 'Sim' });
        }

        if (this.lotsSelectedWarehouse && this.lotsSelectedWarehouse.id) {
          appliedFilters.push({ label: 'Armazém', value: this.lotsSelectedWarehouse.name });
        }

        if (this.lotsSelectedLocation && this.lotsSelectedLocation.id) {
          appliedFilters.push({ label: 'Endereço', value: this.lotsSelectedLocation.name });
        }

        return appliedFilters;
      },

      generatePDFButtonDisabled() {
        return !this.barcodePrintModel || !this.barcodePrintModel.label || this.loadingBarcodePDF;
      }
    },

    methods: {
      tabChanged() {
        if (!this.itemLotsSearched) {
          this.searchItemLots();
          this.itemLotsSearched = true;
        }
      },

      async getItemLotPrintModels() {
        this.barcodePrintModels = await shared.getItemLotPrintModels(httpClient, { lotOnly: true });
      },

      lotsPageChanged(page) {
        this.lotsCurrentPage = page;
        this.searchItemLots();
      },

      lotsSearchButtonPressed() {
        this.lotsCurrentPage = 1;
        this.searchItemLots();
      },

      openItemLotUpdateModal(index) {
        this.itemLotEditIndex = index;

        this.$nextTick(() => {
          this.$refs.itemLotUpdateModal.showModal();
        });
      },

      itemLotSaved(itemLot) {
        this.itemLots[this.itemLotEditIndex] = Object.assign(this.itemLots[this.itemLotEditIndex], itemLot)
      },

      openBarcodesPrintModal(index) {
        this.showBarcodesPrintModal = true;
        this.printItemLotIndex = index;

        if (
          this.config.printConfig.pinLotModel &&
          this.barcodePrintInitialModel &&
          !this.generatePDFButtonDisabled
        ) {
          this.barcodePrintModel = this.barcodePrintInitialModel;
          this.printBarcodes();
        }
      },

      closeBarcodePrintModal() {
        this.showBarcodesPrintModal = false;
      },

      printBarcodes() {
        let itemLot = this.itemLots[this.printItemLotIndex];
        itemLot.printBarcode = true;
        itemLot.printQuantity = 1;
        let barcodeModels = shared.getBarcodeModelsFromItemLots([itemLot], this.barcodePrintModel);

        if (barcodeModels.length) {
          this.config = shared.setModelAndTemplateIdFromSelectedBarcodeModel(this.config, this.barcodePrintModel);

          this.loadingBarcodePDF = true;
          Axios({
            url: process.env.VUE_APP_API_URL + `item-lots/barcode/pdf`,
            method: 'POST',
            data:  {
              models: barcodeModels,
              options: this.config.printConfig
            },
            responseType: 'blob',
            headers: auth.getAxiosHeaders()
          }).then((response) => {
            this.loadingBarcodePDF = false;
            if (response && response.data && response.data.size) {
              let file = new Blob([response.data], { type: 'application/pdf' });
              let url = window.URL.createObjectURL(file);
              window.open(url);

              this.itemLots[this.printItemLotIndex].printed = true;
              this.closeBarcodePrintModal();
              this.$bvModal.hide('barcodes-print-modal');
            } else {
              this.$notify.textError('Houve um erro ao gerar o PDF. Por favor tente novamente');
            }
          }).catch((error) => {
            this.loadingBarcodePDF = false;

            if (error.response && error.response.headers && error.response.headers.errormessage) {
              this.$notify.textError(error.response.headers.errormessage);
            } else if (error.message) {
              this.$notify.error(error)
            } else {
              this.$notify.textError('Houve um erro ao gerar o PDF. Por favor tente novamente');
            }
          });
        } else {
          this.$notify.textError('Nenhuma impressão selecionada');
        }
      },

      searchItemLots() {
        if (!this.loadingItemLots) {
          this.loadingItemLots = true

          let additionalConditions = [];

          if (this.lotsSearchText && this.lotsSearchText.length) {
            additionalConditions.push({
              field: 'lotNumber',
              conditionalOperator: 'LIKE_START',
              value: this.lotsSearchText
            });
          }

          shared.setLocalStorageString('items/show/Lots/lotsSearchText', this.lotsSearchText);

          if (this.lotsSelectedWarehouse && this.lotsSelectedWarehouse.id) {
            additionalConditions.push({
              field: 'balances.location.stockLocale.id',
              value: this.lotsSelectedWarehouse.id
            });
          }

          shared.setLocalStorageObj('items/show/Lots/lotsSelectedWarehouse', this.lotsSelectedWarehouse);

          if (this.lotsSelectedLocation && this.lotsSelectedLocation.id) {
            additionalConditions.push({
              field: 'balances.location.id',
              value: this.lotsSelectedLocation.id
            });
          }

          shared.setLocalStorageObj('items/show/Lots/lotsSelectedLocation', this.lotsSelectedLocation);

          if (this.onlyPositiveItemLots) {
            additionalConditions.push({
              field: 'balances.entries',
              conditionalOperator: 'GREATER_THAN',
              expressionValue: 'balances.exits'
            });
          }

          shared.setLocalStorageString('items/show/Lots/onlyPositiveItemLots', this.onlyPositiveItemLots);

          httpClient
          .post(`${process.env.VUE_APP_API_URL}item-lots/item/${this.item.id}?page=${this.lotsCurrentPage - 1}&size=${this.lotsPerPage}&sort=createdAt,desc&sort=lotNumber,asc`, {
            startDate: this.lotsStartDateStr + 'T00:00:00.000Z',
            endDate: this.lotsEndDateStr + 'T23:59:59.999Z',
            additionalConditions: additionalConditions
          })
          .then(({ data }) => {
            this.itemLots = data.data.content;
            this.lotsTotalRows = data.data.totalElements;
            this.lotsSearchedCallback(data.data.content);

            if (this.itemLots) {
              this.itemLots.forEach(itemLot => {
                if (itemLot.createdAt) {
                  itemLot.formattedDate = shared.formatDate(itemLot.createdAt);
                }

                if (itemLot.due) {
                  itemLot.formattedDue = shared.formatDate(itemLot.due, { dateOnly: true });
                }

                itemLot.printQuantity = 0;
              });
            }

            this.loadingItemLots = false
          })
          .catch((error) => {
            if (error.message) {
              this.$notify.error(error)
            }
            this.itemLots = [];
            this.loadingItemLots = false
          });
        }
      },

      locationsFilterChanged($event) {
        this.searchLocations($event, conditions => {
          if (this.lotsSelectedWarehouse && this.lotsSelectedWarehouse.id) {
            conditions.push({
              field: 'stockLocale.id',
              value: this.lotsSelectedWarehouse.id
            });
          }

          return conditions;
        });
      }
    },

    watch: {
      'lotsSelectedWarehouse': function(newVal, oldVal) {
        if (!shared.entitiesAreEqual(newVal, oldVal)) {
          this.locationsFilter.locations = [];
        }
      }
    }
  }
</script>

<style scoped>
</style>
